import { createReducer, on } from '@ngrx/store';
import { NoParkingZone } from '../../../modules/no-parking-zones/interfaces';
import * as fromNoParkingZones from '../actions/no-parking-zones.actions';

export interface NoParkingZoneState {
    entities: { [id: string]: NoParkingZone };
}

export const initialState: NoParkingZoneState = {
    entities: {}
};

export const noParkingZoneReducer = createReducer(
    initialState,
    on(fromNoParkingZones.CreateNoParkingZone, (state, { payload }) => ({
        ...state,
        entities: { ...state.entities, [payload.properties.id]: payload }
    })),
    on(fromNoParkingZones.EditNoParkingZone, (state, { payload }) => ({
        ...state,
        entities: Object.keys(state.entities).reduce((accumulator: { [id: string]: NoParkingZone }, key: string) => {
            accumulator[key] = key === payload.properties.id ? payload : state.entities[key];
            return accumulator;
        }, {})
    })),
    on(fromNoParkingZones.DeleteNoParkingZone, (state, { payload }) => ({
        ...state,
        entities: Object.keys(state.entities)
            .filter((key: string) => key !== payload)
            .reduce(
                (entities: { [_id: string]: NoParkingZone }, currId: string) => (
                    (entities[currId] = state.entities[currId]), entities
                ),
                {}
            )
    })),
    on(fromNoParkingZones.UploadNoParkingZones, (state, { payload }) => ({
        ...state,
        entities: payload.reduce(
            (accumulator: { [_id: string]: NoParkingZone }, currentZone: NoParkingZone) => {
                if (!accumulator[currentZone.properties.id]) {
                    accumulator[currentZone.properties.id] = currentZone;
                }
                return accumulator;
            },
            { ...state.entities }
        )
    }))
);

export const getNoParkingZonesEntities = (state: NoParkingZoneState) => state.entities;
